import React, { useState, useEffect } from 'react';
import NoPagination from '../pagination/noPagination';
import Api from '../../api/global.service';
import { Link } from 'react-router-dom';
import EditLink from '../link/edit-link';
import LabelNumber from '../label/label-number';
import updateLocalData from '../../utils/updateLocalData';
import updateLocalDataAndParent from '../../utils/updateLocalDataAndParent';
import parsePoint from '../../utils/parsePoint';
import { useAuth } from '../content/auth';
// import env from '../../environment';
import transformWord from '../../utils/transformWord';

// columnas que sólo aplican a cooperativas de café
const soloCafe = ['poligono_area', 'edad_plantas', 'rendimiento_ha', 'cafe_vendido_cicloanterior_coop'];

const ModalParcelas = ({
  id_cuenta,
  nombreProductor,
  id_ciclo,
  unitConversions,
  dataPadron,
  isMielCoop,
  isCafeCoop,
  mostrarAreaCalculada,
  producto = 'café',
  show,
  handleClose,
  onClickEdit,
  onClickEditNumber,
  updateParentData,
  updateParentDataOriginal,
  parentRow,
  etiquetas,
}) => {
  const [data, setData] = useState([]);
  const [blocking, setBlocking] = useState(true);
  const [editing, setEditing] = useState(false);
  const auth = useAuth();
  const productoUpper = transformWord(producto, ['uppercase']);
  const productoLower = transformWord(producto, ['lowercase']);

  useEffect(() => {
    if (id_cuenta && id_ciclo) {
      setBlocking(true);
      Api.get(`tx_parcelas_productor_padron/${id_ciclo}`, id_cuenta)
        .then(response => {
          setData(response.data);
          setBlocking(false);
        })
        .catch(e => {
          // eslint-disable-next-line no-console
          console.log('error:', e);
          setBlocking(false);
        });
    }
    setEditing(false);
  }, [id_cuenta, id_ciclo]);

  const columns = React.useMemo(() => [
    {
      Header: `${transformWord(etiquetas?.parcela, ['plural','uppercase'])} CULTIVO ORGÁNICO`,
      columns: [
        {
          Header: 'Ciclo Actual',
          columns: [
            {
              Header: `NOMBRE DE${isMielCoop ? 'L' : ''} ${transformWord(etiquetas?.parcela, ['singular','uppercase'])}`,
              accessor: 'nombre',
              sortable: true,
              minWidth: 50,
              Cell: ({ row, value }) => {
                const editData = {
                  ...row.original,
                  type: 'text',
                  accessor: 'parcela_nombre',
                  columnName: `NOMBRE DE${isMielCoop ? 'L' : ''} ${transformWord(etiquetas?.parcela, ['singular','uppercase'])}`,
                  nombreProductor: nombreProductor,
                  oldValue: value,
                  nombreParcela: value,
                  id_cuenta: id_cuenta,
                  id_sic_informacion_general: row.original.id_sic_informacion_general,
                  id_parcela: row.original.id,
                  onClose: setEditing,
                  setData: newValue => updateLocalData({ nombre: newValue }, setData, row.index),
                };
                if (row.original.uuid !== null) {
                  const updatedClass = Array.isArray(row.original.updated) && row.original.updated.includes('nombre') ? 'updated' : '';
                  return (
                    <div
                      className={updatedClass}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                      }}>
                      <Link to={{ pathname: `/admin/parcelas/perfil/${row.original.uuid}` }} className="m-r-2" style={{ color: '#789D16' }}>
                        <span>{value}</span>
                      </Link>
                      <div className="edit_hover_class" style={{ minWidth: '45px', paddingLeft: '15px' }}>
                        <EditLink
                          onClickEdit={e => {
                            onClickEdit(e, editData);
                            setEditing(true);
                          }}
                        />
                      </div>
                    </div>
                  );
                } else {
                  return (
                    <EditLink onClickEdit={e => onClickEdit(e, editData)} column="nombre" updated={row.original.updated}>
                      <p style={{ margin: 0 }}>{value}</p>
                    </EditLink>
                  );
                }
              },
            },
            {
              Header: `SUPERFICIE REPORTADA DE${isMielCoop ? 'L' : ''} ${transformWord(etiquetas?.parcela, ['singular','uppercase'])} (ha)`,
              accessor: 'tx_superficie',
              sortable: true,
              minWidth: 50,
              Cell: ({ row, value }) => {
                const editData = {
                  type: 'number',
                  accessor: 'tx_superficie',
                  oldValue: value,
                  columnName: `SUPERFICIE REPORTADA DE${isMielCoop ? 'L' : ''} ${transformWord(etiquetas?.parcela, ['singular','uppercase'])} (ha)`,
                  nombreProductor: nombreProductor,
                  nombreParcela: row.original.nombre,
                  id_cuenta: id_cuenta,
                  id_ciclo: id_ciclo,
                  id_sic_informacion_general: row.original.id_sic_informacion_general,
                  id_parcela: row.original.id,
                  onClose: setEditing,
                  setData: newValue =>
                    updateLocalDataAndParent(
                      newValue,
                      'tx_superficie',
                      setData,
                      value,
                      row.index,
                      updateParentData,
                      'cuenta_superficie_total',
                      parentRow,
                      parseFloat,
                      updateParentDataOriginal,
                      id_cuenta
                    ),
                };
                return (
                  <EditLink
                    onClickEdit={e => {
                      onClickEditNumber(e, editData);
                      setEditing(true);
                    }}
                    column="tx_superficie"
                    updated={row.original.updated}>
                    <LabelNumber value={value} digits={2}></LabelNumber>
                  </EditLink>
                );
              },
            },
            {
              Header: 'SUPERFICIE CALCULADA DEL POLÍGONO (ha)',
              accessor: 'poligono_area',
              sortable: true,
              minWidth: 50,
              show: !!isCafeCoop && !!mostrarAreaCalculada,
              Cell: ({ value }) => <LabelNumber value={value} digits={2} />,
            },
            {
              Header: `# DE ${transformWord(etiquetas?.planta, ['plural','uppercase'])}`,
              accessor: 'tx_no_plantas',
              sortable: true,
              minWidth: 50,
              Cell: ({ row, value }) => {
                const editData = {
                  type: 'number',
                  accessor: 'tx_no_plantas',
                  oldValue: value,
                  columnName: `# DE ${transformWord(etiquetas?.planta, ['plural','uppercase'])}`,
                  nombreProductor: nombreProductor,
                  nombreParcela: row.original.nombre,
                  id_cuenta: id_cuenta,
                  id_ciclo: id_ciclo,
                  id_sic_informacion_general: row.original.id_sic_informacion_general,
                  id_parcela: row.original.id,
                  isIngeger: true,
                  onClose: setEditing,
                  setData: newValue =>
                    updateLocalDataAndParent(
                      newValue,
                      'tx_no_plantas',
                      setData,
                      value,
                      row.index,
                      updateParentData,
                      'tx_no_plantas_totales',
                      parentRow,
                      parseInt,
                      updateParentDataOriginal,
                      id_cuenta
                    ),
                };
                return (
                  <EditLink
                    onClickEdit={e => {
                      onClickEditNumber(e, editData);
                      setEditing(true);
                    }}
                    column="tx_no_plantas"
                    updated={row.original.updated}>
                    <LabelNumber value={value}></LabelNumber>
                  </EditLink>
                );
              },
            },
            {
              Header: `EDAD DE ${transformWord(etiquetas?.planta, ['plural','uppercase'])}`,
              accessor: 'edad_plantas',
              sortable: true,
              minWidth: 150,
              show: !!isCafeCoop,
            },
            {
              Header: `ESTIMACIÓN DE COSECHA ${productoUpper} ` + unitConversions?.estimacion_cosecha_label,
              accessor: 'tx_estimacion_cosecha_inspector_or',
              sortable: true,
              minWidth: 50,
              Cell: ({ row, value }) => {
                // get unit conversion values
                const estimacionCV = dataPadron[parentRow]?.['tx_estimacion_cosecha_inspector_total_conv_cv'];
                // get calculations to display in label
                const getInfoLabel = currentValue => {
                  const calculated = parseFloat(currentValue || 0) * estimacionCV;
                  return {
                    value: calculated.toFixed(2),
                    label: calculated.toFixed(2) + ' KGS',
                    column: 'tx_estimacion_cosecha_inspector',
                    parentColumn: 'tx_estimacion_cosecha_inspector_total',
                    oldValue: parseFloat(value || 0) * estimacionCV,
                  };
                };
                const editData = {
                  type:
                    unitConversions?.estimacion_cosecha_label && unitConversions?.estimacion_cosecha_label !== 'KGS'
                      ? 'numberLabel'
                      : 'number',
                  accessor: 'tx_estimacion_cosecha_inspector_or',
                  oldValue: value,
                  columnName: `ESTIMACIÓN DE COSECHA ${productoUpper} ` + unitConversions?.estimacion_cosecha_label,
                  getInfoLabel: getInfoLabel,
                  nombreProductor: nombreProductor,
                  nombreParcela: row.original.nombre,
                  id_cuenta: id_cuenta,
                  id_sic_informacion_general: row.original.id_sic_informacion_general,
                  id_parcela: row.original.id,
                  onClose: setEditing,
                  setData: (newValue, infoLabel) =>
                    updateLocalDataAndParent(
                      newValue,
                      'tx_estimacion_cosecha_inspector_or',
                      setData,
                      value,
                      row.index,
                      updateParentData,
                      'tx_estimacion_cosecha_inspector_or_total',
                      parentRow,
                      parseFloat,
                      updateParentDataOriginal,
                      id_cuenta,
                      infoLabel
                    ),
                };
                return (
                  <EditLink
                    onClickEdit={e => {
                      onClickEditNumber(e, editData);
                      setEditing(true);
                    }}
                    column="tx_estimacion_cosecha_inspector_or"
                    updated={row.original.updated}>
                    <LabelNumber value={value} digits={2}></LabelNumber>
                  </EditLink>
                );
              },
            },
            {
              Header: `ESTIMACIÓN DE COSECHA ${productoUpper} KGS`,
              accessor: 'tx_estimacion_cosecha_inspector',
              sortable: true,
              minWidth: 50,
              show: auth.user.id_cooperativa != 3,
              Cell: ({ row, value }) => {
                // get unit conversion values
                const estimacionCV = dataPadron[parentRow]?.['tx_estimacion_cosecha_inspector_total_conv_cv'];
                // get calculations to display in label
                const getInfoLabel = currentValue => {
                  const calculated = parseFloat(currentValue || 0) / estimacionCV;
                  return {
                    value: calculated.toFixed(2),
                    label: calculated.toFixed(2) + ' ' + unitConversions?.estimacion_cosecha_label,
                    column: 'tx_estimacion_cosecha_inspector_or',
                    parentColumn: 'tx_estimacion_cosecha_inspector_or_total',
                    oldValue: parseFloat(value || 0) / estimacionCV,
                  };
                };
                const editData = {
                  type:
                    unitConversions?.estimacion_cosecha_label && unitConversions?.estimacion_cosecha_label !== 'KGS'
                      ? 'numberLabel'
                      : 'number',
                  accessor: 'tx_estimacion_cosecha_inspector',
                  oldValue: value,
                  columnName: `ESTIMACIÓN DE COSECHA ${productoUpper} KGS`,
                  getInfoLabel: getInfoLabel,
                  nombreProductor: nombreProductor,
                  nombreParcela: row.original.nombre,
                  id_cuenta: id_cuenta,
                  id_sic_informacion_general: row.original.id_sic_informacion_general,
                  id_parcela: row.original.id,
                  onClose: setEditing,
                  setData: (newValue, infoLabel) =>
                    updateLocalDataAndParent(
                      newValue,
                      'tx_estimacion_cosecha_inspector',
                      setData,
                      value,
                      row.index,
                      updateParentData,
                      'tx_estimacion_cosecha_inspector_total',
                      parentRow,
                      parseFloat,
                      updateParentDataOriginal,
                      id_cuenta,
                      infoLabel
                    ),
                };
                return (
                  <EditLink
                    onClickEdit={e => {
                      onClickEditNumber(e, editData);
                      setEditing(true);
                    }}
                    column="tx_estimacion_cosecha_inspector"
                    updated={row.original.updated}>
                    <LabelNumber value={value} digits={2}></LabelNumber>
                  </EditLink>
                );
              },
            },
            {
              Header: `ESTIMACIÓN DE ENTREGA DE ${productoUpper} (PRODUCTOR) ` + unitConversions?.estimacion_cosecha_label,
              accessor: 'tx_estimacion_cosecha_productor_or',
              sortable: true,
              minWidth: 50,
              show: !isMielCoop,
              Cell: ({ row, value }) => {
                const editData = {
                  type: 'number',
                  accessor: 'tx_estimacion_cosecha_productor_or',
                  oldValue: value,
                  columnName: `ESTIMACIÓN DE ENTREGA DE ${productoUpper} (PRODUCTOR) ` + unitConversions?.estimacion_cosecha_label,
                  nombreProductor: nombreProductor,
                  nombreParcela: row.original.nombre,
                  id_cuenta: id_cuenta,
                  id_sic_informacion_general: row.original.id_sic_informacion_general,
                  id_parcela: row.original.id,
                  onClose: setEditing,
                  setData: newValue =>
                    updateLocalDataAndParent(
                      newValue,
                      'tx_estimacion_cosecha_productor_or',
                      setData,
                      value,
                      row.index,
                      updateParentData,
                      'tx_estimacion_cosecha_productor_or_total',
                      parentRow,
                      parseFloat,
                      updateParentDataOriginal,
                      id_cuenta
                    ),
                };
                return (
                  <EditLink
                    onClickEdit={e => {
                      onClickEditNumber(e, editData);
                      setEditing(true);
                    }}
                    column="tx_estimacion_cosecha_productor_or"
                    updated={row.original.updated}>
                    <LabelNumber value={value} digits={2}></LabelNumber>
                  </EditLink>
                );
              },
            },
            {
              Header: `ESTIMACIÓN DE ENTREGA DE ${productoUpper} (PRODUCTOR) KGS`,
              accessor: 'tx_estimacion_cosecha_productor',
              sortable: true,
              minWidth: 50,
              show: !isMielCoop,
              Cell: ({ row, value }) => {
                const editData = {
                  type: 'number',
                  accessor: 'tx_estimacion_cosecha_productor',
                  oldValue: value,
                  columnName: `ESTIMACIÓN DE ENTREGA DE ${productoUpper} (PRODUCTOR) KGs`,
                  nombreProductor: nombreProductor,
                  nombreParcela: row.original.nombre,
                  id_cuenta: id_cuenta,
                  id_sic_informacion_general: row.original.id_sic_informacion_general,
                  id_parcela: row.original.id,
                  onClose: setEditing,
                  setData: newValue =>
                    updateLocalDataAndParent(
                      newValue,
                      'tx_estimacion_cosecha_productor',
                      setData,
                      value,
                      row.index,
                      updateParentData,
                      'tx_estimacion_cosecha_productor_total',
                      parentRow,
                      parseFloat,
                      updateParentDataOriginal,
                      id_cuenta
                    ),
                };
                return (
                  <EditLink
                    onClickEdit={e => {
                      onClickEditNumber(e, editData);
                      setEditing(true);
                    }}
                    column="tx_estimacion_cosecha_productor"
                    updated={row.original.updated}>
                    <LabelNumber value={value} digits={2}></LabelNumber>
                  </EditLink>
                );
              },
            },
            {
              Header: 'ESTIMACIÓN DE COSECHA CACAO',
              accessor: 'max_actual_cacao',
              sortable: true,
              minWidth: 50,
              show: auth.user.id_cooperativa == 36,
              Cell: ({ value }) => (
                <div>
                  <LabelNumber value={value} digits={2} />
                </div>
              ),
            },
            {
              Header: 'ESTIMACIÓN DE COSECHA PIMIENTA GORDA',
              accessor: 'max_actual_pimientanegra',
              sortable: true,
              minWidth: 50,
              show: auth.user.id_cooperativa == 56,
              Cell: ({ row, value }) => {
                const editData = {
                  type: 'number',
                  accessor: 'max_actual_pimientanegra',
                  oldValue: value,
                  columnName: 'ESTIMACIÓN DE COSECHA PIMIENTA GORDA',
                  nombreProductor: nombreProductor,
                  nombreParcela: row.original.nombre,
                  id_cuenta: id_cuenta,
                  id_sic_informacion_general: row.original.id_sic_informacion_general,
                  id_parcela: row.original.id,
                  onClose: setEditing,
                  setData: newValue =>
                    updateLocalDataAndParent(
                      newValue,
                      'max_actual_pimientanegra',
                      setData,
                      value || 0,
                      row.index,
                      updateParentData,
                      'sum_actual_pimientanegra',
                      parentRow,
                      parseFloat,
                      updateParentDataOriginal,
                      id_cuenta
                    ),
                };
                return (
                  <EditLink
                    onClickEdit={e => {
                      onClickEditNumber(e, editData);
                      setEditing(true);
                    }}
                    column="max_actual_pimientanegra"
                    updated={row.original.updated}>
                    <LabelNumber value={value} digits={2}></LabelNumber>
                  </EditLink>
                );
              },
            },
            {
              Header: 'ESTIMACIÓN DE COSECHA MANÍ',
              accessor: 'max_actual_mani',
              sortable: true,
              minWidth: 50,
              show: auth.user.id_cooperativa == 36,
              Cell: ({ value }) => (
                <div>
                  <LabelNumber value={value} digits={2} />
                </div>
              ),
            },
            {
              Header: 'ESTIMACIÓN DE COSECHA CARDAMOMO',
              accessor: 'max_actual_cardamomo',
              sortable: true,
              minWidth: 50,
              show: auth.user.id_cooperativa == 36,
              Cell: ({ value }) => (
                <div>
                  <LabelNumber value={value} digits={2} />
                </div>
              ),
            },
            {
              Header: `${transformWord(etiquetas?.parcela, ['singular','uppercase'])} DIGITALIZAD${isMielCoop ? 'O' : 'A'}`,
              accessor: 'croquis_digitalizado',
              sortable: true,
              minWidth: 50,
            },
            {
              Header: 'CENTROIDE',
              accessor: 'centroide',
              sortable: true,
              minWidth: 50,
              Cell: ({ row }) => {
                return (
                  <p>
                    {/* TODO: Lat/Long are inverted in backend. Fix when sql fix and all logic is updated */}
                    Lat:{parsePoint(row.original.centroide_lng, 4)} / Lon: {parsePoint(row.original.centroide_lat, 4)}
                  </p>
                );
              },
            },
            {
              Header: 'CULTIVO A CERTIFICAR',
              accessor: 'cultivos_activos',
              sortable: true,
              minWidth: 50,
              show: auth.user.id_cooperativa == 36 || auth.user.id_cooperativa == 56,
            },
          ].filter(column => {
            // hide columns - replacing the "show" property due not working in some cases
            if (column.accessor === 'poligono_area') {
              return !!isCafeCoop && !!mostrarAreaCalculada;
            } else if (soloCafe.includes(column.accessor)) {
              return !!isCafeCoop;
            } else if (column.accessor === 'tx_estimacion_cosecha_inspector_or') {
              return (
                auth.user.id_cooperativa != 3 &&
                unitConversions?.estimacion_cosecha_label &&
                unitConversions?.estimacion_cosecha_label !== 'KGS'
              );
            } else if (column.accessor === 'tx_estimacion_cosecha_productor_or') {
              return unitConversions?.estimacion_cosecha_label && unitConversions?.estimacion_cosecha_label !== 'KGS';
            }
            return true;
          }),
        },
        {
          Header: 'Ciclo Pasado',
          columns: [
            {
              Header: `SUPERFICIE DE${isMielCoop ? 'L' : ' LA'} ${transformWord(etiquetas?.parcela, ['singular','uppercase'])} (ha ${productoUpper})`,
              accessor: 'sup_anterior',
              sortable: true,
              minWidth: 50,
              Cell: ({ row }) => {
                const parcelaPreviousCycle = row.original.parcelas_previous_ciclo;
                if (parcelaPreviousCycle && parcelaPreviousCycle.length === 1) {
                  return <LabelNumber value={parcelaPreviousCycle[0].inspeccion_superficie_cafe} digits={2} />;
                }
                return null;
              },
            },
            {
              Header: `# DE ${transformWord(etiquetas?.planta, ['plural','uppercase'])}`,
              accessor: 'parcelas[0].num_plantas_anterior',
              sortable: true,
              minWidth: 50,
              Cell: ({ row }) => {
                const parcelaPreviousCycle = row.original.parcelas_previous_ciclo;
                if (parcelaPreviousCycle && parcelaPreviousCycle.length === 1) {
                  return <LabelNumber value={parcelaPreviousCycle[0].tx_no_plantas} digits={2} />;
                }
                return null;
              },
            },
            {
              Header: `ESTIMACIÓN DE COSECHA KGs ${productoUpper}`,
              accessor: 'parcelas[0].estimacion_anterior',
              sortable: true,
              minWidth: 50,
              Cell: ({ row }) => {
                const parcelaPreviousCycle = row.original.parcelas_previous_ciclo;
                if (parcelaPreviousCycle && parcelaPreviousCycle.length === 1) {
                  return <LabelNumber value={parcelaPreviousCycle[0].tx_estimacion_cosecha_inspector} digits={2}></LabelNumber>;
                }
                return null;
              },
            },
            // Rendimiento y kgs entregados del ciclo anterior se capturan en la ficha del ciclo actual
            {
              Header: 'RENDIMIENTO DE COSECHA CICLO ANTERIOR (kg/ha)',
              accessor: 'rendimiento_ha',
              sortable: true,
              minWidth: 50,
              show: !!isCafeCoop,
              Cell: ({ value }) => <LabelNumber value={value} digits={2} />,
            },
            {
              Header: 'KGS ENTREGADOS A LA ORGANIZACIÓN EN LA COSECHA ANTERIOR',
              accessor: 'cafe_vendido_cicloanterior_coop',
              sortable: true,
              minWidth: 50,
              show: !!isCafeCoop,
              Cell: ({ value }) => <LabelNumber value={value} digits={2} />,
            },
            {
              Header: 'CULTIVO ANTERIOR',
              accessor: 'tx_cultivo_anterior',
              sortable: true,
              minWidth: 50,
            },
          ].filter(column => !soloCafe.includes(column.accessor) || !!isCafeCoop),
        },
      ],
    },
  ],[etiquetas, dataPadron, parentRow, nombreProductor, id_cuenta, id_ciclo, unitConversions, isMielCoop, isCafeCoop, mostrarAreaCalculada, productoUpper, productoLower, onClickEdit, onClickEditNumber, updateParentData, updateParentDataOriginal]);

  const onClose = () => {
    setData([]);
    handleClose();
  };

  const getBackgroundColor = (row, column) => {
    if (row === 1) {
      if (column % 2 === 0) return '#5F5F59';
      return '#91918A';
    }
    return 'rgba(240, 224, 207, 1.0)';
  };

  const getColor = row => (row === 1 ? 'white' : 'rgb(95, 95, 89)');

  return (
    <div className="modal" style={{ display: show ? 'block' : 'none', backgroundColor: 'rgba(0,0,0,0.2)' }}>
      <div
        style={{
          top: 50,
          left: 25,
          position: 'absolute',
          width: editing ? 'calc(96% - 415px)' : '96%',
          backgroundColor: 'white',
          padding: '20px',
          borderRadius: '20px 20px 20px 20px',
          border: '1px solid #000',
        }}>
        <button
          onClick={onClose}
          type="button"
          className="btn btn-outline-secondary"
          style={{ borderRadius: '20px 20px 20px 20px', position: 'absolute', right: '10px', top: '10px' }}>
          <i className="fa fa-times"></i>
        </button>
        <h4>{transformWord(etiquetas?.parcela, ['plural','capitalize'])} de {nombreProductor}</h4>
        <NoPagination
          blocking={blocking}
          columns={columns}
          data={data}
          pagination={false}
          fnBackgroundColor={getBackgroundColor}
          fnColor={getColor}
        />
      </div>
    </div>
  );
};

export default ModalParcelas;
